import { createClient } from '@supabase/supabase-js';

// Get environment variables
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Development diagnostics
if (import.meta.env.DEV) {
  console.log('🔧 Supabase Configuration Check:');
  console.log('URL:', supabaseUrl || 'NOT SET');
  console.log('Key:', supabaseAnonKey ? 'SET (' + supabaseAnonKey.substring(0, 20) + '...)' : 'NOT SET');

  if (!supabaseUrl || !supabaseAnonKey) {
    console.error('❌ Supabase not configured (missing environment variables)');
  }

  if (supabaseUrl && !supabaseUrl.includes('.supabase.co')) {
    console.error('❌ Supabase URL domain must end with .supabase.co → got:', supabaseUrl);
  }

  if (supabaseUrl === 'https://your-project-ref.supabase.co') {
    console.error('❌ Please replace placeholder Supabase URL with your actual project URL');
  }

  if (supabaseAnonKey === 'your-anon-key-here') {
    console.error('❌ Please replace placeholder Supabase key with your actual anon key');
  }
}

// Create Supabase client only if we have valid configuration
let supabase = null;

if (
  supabaseUrl && 
  supabaseAnonKey && 
  supabaseUrl.includes('.supabase.co') && 
  supabaseUrl !== 'https://your-project-ref.supabase.co' && 
  supabaseAnonKey !== 'your-anon-key-here'
) {
  try {
    supabase = createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        flowType: 'pkce'
      }
    });

    if (import.meta.env.DEV) {
      console.log('✅ Supabase client created successfully');
    }
  } catch (error) {
    console.error('❌ Failed to create Supabase client:', error);
  }
} else {
  console.warn('⚠️ Supabase client not created - using localStorage fallback');
  console.warn('Please check your .env file and ensure you have:');
  console.warn('VITE_SUPABASE_URL=https://your-project-ref.supabase.co');
  console.warn('VITE_SUPABASE_ANON_KEY=your-anon-key-here');
}

export { supabase };
export default supabase;